import { forwardRef } from 'react'

import Product from '@/ts/Product'

import Thumb from './includes/Thumb'

const Thumbnails = forwardRef<HTMLDivElement, ThumbnailsProps>((props, ref) => {
  const { product, onClick, currentSlide } = props
  const { images, type, name } = product

  return (
    <div
      className="relative hidden w-full h-full px-4 overflow-hidden md:flex md:justify-center xl:px-0 2sm:px-8"
      ref={ref}
    >
      <div className="flex w-full h-full space-x-4 max-w-max">
        {images.map(({ src }, index) => (
          <Thumb
            key={src}
            type={type}
            isSelected={index === currentSlide}
            onClick={() => onClick(index)}
          >
            <img
              className="absolute top-0 left-0 object-cover w-full h-full"
              alt={name}
              src={src}
            />
          </Thumb>
        ))}
      </div>
    </div>
  )
})

interface ThumbnailsProps {
  product: Product
  onClick(index: number): void
  currentSlide: number
}

export default Thumbnails
